import { createSlice, nanoid } from "@reduxjs/toolkit";
import { resetData } from "../app/reducer";

const INITIAL_STATE = {
  travelMode: "CAR",
  startLocation: null,
  endLocation: [
    {
      id: nanoid(),
      value: null,
    },
  ],
  pathUrls: [],
};

const directionSlice = createSlice({
  name: "direction",
  initialState: INITIAL_STATE,
  reducers: {
    setTravelMode: (state, { payload: { mode } }) => {
      return {
        ...state,
        travelMode: mode,
      };
    },
    setStartLocation: (state, { payload: { location } }) => {
      return {
        ...state,
        startLocation: location,
      };
    },
    setEndLocation: (state, { payload: { id, location } }) => {
      return {
        ...state,
        endLocation: [
          // ...state.endLocation,
          {
            id: id,
            value: location,
          },
        ],
      };
    },

    addEndLocation: (state) => {
      return {
        ...state,
        endLocation: [
          ...state.endLocation,
          {
            id: nanoid(),
            value: null,
          },
        ],
      };
    },
    removeEndLocation: (state, { payload: { id } }) => {
      return {
        ...state,
        endLocation: state.endLocation.filter((location) => location.id !== id),
      };
    },

    updateEndLocation: (state, { payload: { id, location } }) => {
      // console.log("update location",id ,location)
      // console.log("update location",state.endLocation)
      return {
        ...state,
        endLocation: state.endLocation.map((loc) =>
          loc.id === id
            ? {
              ...loc,
              value: location,
            }
            : loc
        ),
      };
    },
    setLocationStart: (state) => {
      return {
        ...state,
      };
    },
    setLocationSucess: (state, { payload: { startLocation, endLocation } }) => {
      return {
        ...state,
        startLocation,
        endLocation: [
          {
            id: nanoid(),
            value: endLocation,
          },
        ],
      };
    },
    setLocationError: (state) => {
      return {
        ...state,
      };
    },
    setSharedLocationStart: (state) => {
      return {
        ...state,
      };
    },
    setSharedLocationSucess: (state, { payload: { pathUrls } }) => {
      return {
        ...state,
        pathUrls,
      };
    },
    setSharedLocationError: (state) => {
      return {
        ...state,
      };
    },
    searchDirectionStart: (state) => {
      return {
        ...state,
      };
    },
    searchDirectionSuccess: (state, { payload: { pathUrls } }) => {
      return {
        ...state,
        pathUrls,
      };
    },
    searchDirectionError: (state) => {
      return {
        ...state,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetData, (state) => {
      return {
        ...state,
        travelMode: "CAR",
        startLocation: null,
        endLocation: [
          {
            id: nanoid(),
            value: null,
          },
        ],
        pathUrls: [],
      };
    });
  },
});

export const {
  setTravelMode,
  setStartLocation,
  setEndLocation,
  addEndLocation,
  removeEndLocation,
  updateEndLocation,
  setLocationStart,
  setLocationSucess,
  setLocationError,
  setSharedLocationStart,
  setSharedLocationSucess,
  setSharedLocationError,
  searchDirectionStart,
  searchDirectionSuccess,
  searchDirectionError,
} = directionSlice.actions;

export default directionSlice.reducer;
